import { GRID_BREAKPOINT_SMALL, GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_LARGE, GRID_BREAKPOINT_EXTRA_LARGE } from 'HubStyleTokens/sizes';
export const device = {
  mobile: `(max-width: ${GRID_BREAKPOINT_SMALL})`,
  tablet: `(max-width: ${GRID_BREAKPOINT_MEDIUM})`,
  laptop: `(max-width: ${GRID_BREAKPOINT_LARGE})`,
  desktop: `(min-width: ${GRID_BREAKPOINT_EXTRA_LARGE})`,
  not: {
    mobile: `(min-width: ${GRID_BREAKPOINT_SMALL})`,
    tablet: `(min-width: ${GRID_BREAKPOINT_MEDIUM})`,
    laptop: `(min-width: ${GRID_BREAKPOINT_LARGE})`
  }
};